import Image from "next/image";
import { useRouter } from "next/router";
import DefaultButton from "@/components/UI/DefaultButton";
import { Container } from "@mantine/core";

const Custom404 = () => {
  const router = useRouter();

  return (
    <div className="error-area">
      <div className="d-table">
        <div className="d-table-cell">
          <Container className="container">
            <div className="error-content">
              <Image width={500} height={198} src="/images/error.png" alt="image" />
              <h3>Error 404 : Page Not Found</h3>
              <p>
                The page you are looking for might have been removed had its name changed or is temporarily unavailable.
              </p>

              <div className="btn-box">
                <DefaultButton
                  text="Homepage"
                  w="fit-content"
                  ml="auto"
                  mr="auto"
                  onClick={() => {
                    router.push("/");
                  }}
                />
              </div>
            </div>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default Custom404;
